module.exports = __webpack_public_path__ + "pdf/financial.e384fda.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/financial.pdf
// module id = aB7h
// module chunks = 0